export type SectionKey =
  | 'intent'
  | 'context'
  | 'yesPlease'
  | 'curiosities'
  | 'softLimits'
  | 'hardLimits'
  | 'safewords'
  | 'aftercare'
  | 'lifeAround'
  | 'exitTerms'
  | 'signature';

export type LetterSections = Record<SectionKey, string>;

export interface Draft {
  id: string;
  title: string;
  recipient?: string;
  sections: LetterSections;
  createdAt: string;
  updatedAt: string;
}

export const EMPTY_SECTIONS: LetterSections = {
  intent: '',
  context: '',
  yesPlease: '',
  curiosities: '',
  softLimits: '',
  hardLimits: '',
  safewords: '',
  aftercare: '',
  lifeAround: '',
  exitTerms: '',
  signature: '',
};
